import React, { useState } from "react"
import { Box, Typography, Menu, MenuItem } from "@mui/material"
import { Helmet } from "react-helmet-async"
import SiteWrapper from "../../home-pages/SiteWrapper"
import EventCard from "./EventCard"
import { parseTimelineDate } from "./util"
import ArrowUpward from "@mui/icons-material/ArrowUpward"
import ArrowDownward from "@mui/icons-material/ArrowDownward"

const eventsData = [
  {
    name: "Jack",
    date: "2025-01-06",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/jack-birthday.jpg",
    category: "birthday",
    family: "Blanchard",
    description: "Born in Provo, Utah."
  },
  {
    name: "Miles",
    date: "2012-03-19",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/miles-birthday.jpg",
    category: "birthday",
    family: "Albretsen",
    description: "Born in Salt Lake City, Utah."
  },
  {
    name: "Logan",
    date: "2016-04-04",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/logan-birthday.jpg",
    category: "birthday",
    family: "Albretsen",
    description: "Born in Salt Lake City, Utah."
  },
  {
    name: "Sadie",
    date: "1998-04-05",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/sadie-birthday.jpg",
    category: "birthday",
    family: "MDymock",
    description: "Born in Provo, Utah."
  },
  {
    name: "Connor",
    date: "2011-04-11",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/connor-birthday.jpg",
    category: "birthday",
    family: "RDymock",
    description: "First grandson, born on his grandma Shirlene's birthday!"
  },
  {
    name: "Shirlene",
    date: "1957-04-11",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/shirlene-birthday.jpg",
    category: "birthday",
    family: "PDymock",
    description: "Born in the spring — the eldest of the line."
  },
  {
    name: "Kenneth",
    date: "2023-04-16",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/kenneth-birthday.jpg",
    category: "birthday",
    family: "Albretsen",
    description: "Born in Salt Lake City, Utah."
  },
  {
    name: "Olivia",
    date: "2020-04-28",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/olivia-birthday.jpg",
    category: "birthday",
    family: "Albretsen",
    description: "Born in Salt Lake City, Utah."
  },
  {
    name: "Marie",
    date: "2016-05-08",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/marie-birthday.jpg",
    category: "birthday",
    family: "RDymock",
    description: "Born in Utah."
  },
  {
    name: "Natalie",
    date: "2015-05-09",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/natalie-birthday.jpg",
    category: "birthday",
    family: "Albretsen",
    description: "Born in Salt Lake City, Utah."
  },
  {
    name: "Kellianne",
    date: "1986-05-15",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/kellianne-birthday.jpg",
    category: "birthday",
    family: "Albretsen",
    description: "Born in Utah, the eldest daughter."
  },
  {
    name: "Leah",
    date: "1986-06-05",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/leah-birthday.jpg",
    category: "birthday",
    family: "RDymock",
    description: "Born in Idaho, bringing joy to her family."
  },
  {
    name: "Beckham",
    date: "2022-06-23",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/beckham-birthday.jpg",
    category: "birthday",
    family: "MDymock",
    description: "Born in Salt Lake City, Utah."
  },
  {
    name: "Ryan",
    date: "1983-07-05",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/ryan-birthday.jpg",
    category: "birthday",
    family: "RDymock",
    description: "Born in Utah, the first son."
  },
  {
    name: "Heidi & Zak",
    date: "2017-07-15",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/hz-anniversary.jpg",
    category: "anniversary",
    family: "Kandare",
    description: "Married on a beautiful summer day."
  },
  {
    name: "Jake",
    date: "2023-07-18",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/jake-birthday.jpg",
    category: "birthday",
    family: "Kandare",
    description: "Born in Salt Lake City, Utah."
  },
  {
    name: "Matthew",
    date: "1998-07-20",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/matthew-birthday.jpg",
    category: "birthday",
    family: "MDymock",
    description: "Born in California, a bright addition to the family."
  },
  {
    name: "Amy & Ethan",
    date: "2017-08-11",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/amye-anniversary.jpg",
    category: "anniversary",
    family: "Blanchard",
    description: "Married on an August afternoon."
  },
  {
    name: "Zak",
    date: "1994-08-16",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/zak-birthday.jpg",
    category: "birthday",
    family: "Kandare",
    description: "Born in Utah."
  },
  {
    name: "Kellianne & Keith",
    date: "2010-08-21",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/kk-anniversary.jpg",
    category: "anniversary",
    family: "Albretsen",
    description: "Married in the Logan Temple."
  },
  {
    name: "Paul & Shirlene",
    date: "1982-08-30",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/ps-anniversary.jpg",
    category: "anniversary",
    family: "PDymock",
    description: "Married in the Salt Lake Temple, beginning their eternal journey."
  },
  {
    name: "Matthew & Sadie",
    date: "2020-09-03",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/ms-anniversary.jpg",
    category: "anniversary",
    family: "MDymock",
    description: "Married in the Salt Lake Temple."
  },
  {
    name: "Ethan",
    date: "1995-09-11",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/ethan-birthday.jpg",
    category: "birthday",
    family: "Blanchard",
    description: "Born in California."
  },
  {
    name: "Dottie",
    date: "2022-09-28",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/dottie-birthday.jpg",
    category: "birthday",
    family: "Blanchard",
    description: "Born in Provo, Utah."
  },
  {
    name: "Samantha",
    date: "2007-10-03",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/samantha-birthday.jpg",
    category: "birthday",
    family: "RDymock",
    description: "Born in Utah."
  },
  {
    name: "Lucy",
    date: "2024-10-11",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/lucy-birthday.jpg",
    category: "birthday",
    family: "Kandare",
    description: "Born in Salt Lake City, bringing smiles to everyone."
  },
  {
    name: "Heidi",
    date: "1990-10-18",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/heidi-birthday.jpg",
    category: "birthday",
    family: "Kandare",
    description: "Born in Utah."
  },
  {
    name: "Ford",
    date: "2020-10-22",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/ford-birthday.jpg",
    category: "birthday",
    family: "Blanchard",
    description: "Born in Utah."
  },
  {
    name: "Ryan & Leah",
    date: "2006-11-18",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/rl.jpg",
    category: "anniversary",
    family: "RDymock",
    description: "Married on a beautiful autumn day in the Logan Temple."
  },
  {
    name: "Keith",
    date: "1985-11-19",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/keith-birthday.jpg",
    category: "birthday",
    family: "Albretsen",
    description: "Born in Utah."
  },
  {
    name: "Rue",
    date: "2018-12-03",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/rue-birthday.jpg",
    category: "birthday",
    family: "Blanchard",
    description: "Born in Utah."
  },
  {
    name: "Amy",
    date: "1994-12-10",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/amy-birthday.jpg",
    category: "birthday",
    family: "Blanchard",
    description: "Born in California."
  },
  {
    name: "Paul",
    date: "1958-12-29",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/paul-birthday.jpg",
    category: "birthday",
    family: "PDymock",
    description: "Born in the winter — the patriarch of the family."
  },
  {
    name: "Adelaide",
    date: "2024-04-29",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/adelaide-birthday.jpg",
    category: "birthday",
    family: "MDymock",
    description: "Born in Utah, a beautiful new granddaughter."
  },
  {
    name: "Sadie Mission Homecoming",
    date: "February 2019",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/sadie-mission-home.jpg",
    category: "mission",
    family: "MDymock",
    description: "Returned home after a successful mission."
  },
  {
    name: "Sadie Mission Departure",
    date: "July 2017",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/sadie-mission-departure.jpg",
    category: "mission",
    family: "MDymock",
    description: "Served in the California Santa Rosa Mission."
  },
  {
    name: "Kellianne Mission Departure",
    date: "June 2007",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/kellianne-mission-departure.jpg",
    category: "mission",
    family: "Albretsen",
    description: "Served in the Germany Berlin Mission."
  },
  {
    name: "Kellianne Mission Homecoming",
    date: "November 2008",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/kellianne-mission-home.jpg",
    category: "mission",
    family: "Albretsen",
    description: "Returned home from Berlin."
  },
  {
    name: "Matthew Mission Departure",
    date: "December 19, 2017",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/matthew-mission-departure.jpg",
    category: "mission",
    family: "MDymock",
    description: "Served in the Mexico Guadalajara Mission."
  },
  {
    name: "Matthew Mission Homecoming",
    date: "December 3, 2019",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/matthew-homecoming.jpg",
    category: "mission",
    family: "MDymock",
    description: "Returned home after two years of service."
  },
  {
    name: "Ryan Mission Departure",
    date: "August 7, 2002",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/ryan-mission-departure.jpg",
    category: "mission",
    family: "Albretsen",
    description: "Served in the Baltic States Mission (Lithuania)."
  },
  {
    name: "Ryan Mission Homecoming",
    date: "August 9, 2004",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/ryan-mission-home.jpg",
    category: "mission",
    family: "Albretsen",
    description: "Returned home after two years of faithful service."
  },
  {
    name: "Paul Mission Departure",
    date: "March 1, 1978",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/paul-mission-departure.jpg",
    category: "mission",
    family: "PDymock",
    description: "Called to serve in the Japan Fukuoka Mission."
  },
  {
    name: "Paul Mission Homecoming",
    date: "March 1980",
    avatar: "placeholder_avatar.jpg",
    cardImage: "images/timeline/paul-mission-home.jpg",
    category: "mission",
    family: "PDymock",
    description: "Returned home after two years of faithful service."
  }
]

const monthNames = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
]

const allFamiliesList = [
  "PDymock",
  "Kandare",
  "Blanchard",
  "RDymock",
  "MDymock",
  "Albretsen"
]

const DecadeHeader = ({ decade }) => (
  <Box sx={{ display: "flex", alignItems: "center", mb: 4, mt: 4, position: "relative" }}>
    {/* Solid dot on the rail */}
    <Box
      sx={{
        position: "absolute",
        left: "40px",
        transform: "translateX(-50%)",
        width: "14px",
        height: "14px",
        borderRadius: "50%",
        backgroundColor: "#8C4E35", // terracotta
        zIndex: 2,
      }}
    />
    {/* Decade text */}
    <Box sx={{ ml: "70px" }}>
      <Typography
        sx={{
          fontFamily: '"Playfair Display", Georgia, serif',
          fontSize: { xs: "2rem", md: "2.5rem" },
          color: "#C4B49F", // light golden-tan
          fontWeight: 400,
          lineHeight: 1,
        }}
      >
        {decade}s
      </Typography>
    </Box>
  </Box>
)

const MonthHeader = ({ month }) => (
  <Box sx={{ display: "flex", alignItems: "center", mb: 4, mt: 4, position: "relative" }}>
    {/* Solid dot on the rail */}
    <Box
      sx={{
        position: "absolute",
        left: "40px",
        transform: "translateX(-50%)",
        width: "14px",
        height: "14px",
        borderRadius: "50%",
        backgroundColor: "#8C4E35",
        zIndex: 2,
      }}
    />
    {/* Month text */}
    <Box sx={{ ml: "70px" }}>
      <Typography
        sx={{
          fontFamily: '"Playfair Display", Georgia, serif',
          fontSize: { xs: "2rem", md: "2.5rem" },
          color: "#C4B49F",
          fontWeight: 400,
          lineHeight: 1,
        }}
      >
        {monthNames[month]}
      </Typography>
    </Box>
  </Box>
)

const FamilyTimeline = () => {
  const [sortMode, setSortMode] = useState("absolute")
  const [sortDirection, setSortDirection] = useState("asc")
  const [selectedCategories, setSelectedCategories] = useState([
    "anniversary",
    "birthday",
    "mission",
  ])
  const [selectedFamilies, setSelectedFamilies] = useState([...allFamiliesList])
  const [familyMenuAnchor, setFamilyMenuAnchor] = useState(null)

  // Handlers for family menu dropdown
  const handleFamilyClick = (event) => {
    setFamilyMenuAnchor(event.currentTarget)
  }

  const handleFamilyClose = () => {
    setFamilyMenuAnchor(null)
  }

  const toggleFamily = (fam) => {
    if (selectedFamilies.includes(fam)) {
      setSelectedFamilies(selectedFamilies.filter((f) => f !== fam))
    } else {
      setSelectedFamilies([...selectedFamilies, fam])
    }
  }

  const toggleCategory = (cat) => {
    if (selectedCategories.includes(cat)) {
      setSelectedCategories(selectedCategories.filter((c) => c !== cat))
    } else {
      setSelectedCategories([...selectedCategories, cat])
    }
  }

  const getFamilyButtonText = () => {
    if (selectedFamilies.length === allFamiliesList.length) {
      return "All families"
    }
    if (selectedFamilies.length === 0) {
      return "No families"
    }
    return `${selectedFamilies.length} families`
  }

  // Filter events based on category and family selections.
  const filteredData = eventsData.filter(
    (event) =>
      selectedCategories.includes(event.category) &&
      selectedFamilies.includes(event.family)
  )

  // Sort data based on chosen sort mode and direction.
  const sortedData = [...filteredData].sort((a, b) => {
    const aDate = parseTimelineDate(a.date)
    const bDate = parseTimelineDate(b.date)
    if (sortMode === "absolute") {
      return sortDirection === "asc" ? aDate - bDate : bDate - aDate
    } else {
      // Sort by month and day, ignoring the year.
      const aMonth = aDate.getMonth()
      const bMonth = bDate.getMonth()
      const aDay = aDate.getDate()
      const bDay = bDate.getDate()
      let diff = 0
      if (aMonth === bMonth) {
        diff = aDay - bDay
      } else {
        diff = aMonth - bMonth
      }
      return sortDirection === "asc" ? diff : -diff
    }
  })

  // Build the list of elements programmatically grouping by decade or month.
  let lastDecade = null
  let lastMonth = null
  const elements = []

  sortedData.forEach((event, index) => {
    const dateObj = parseTimelineDate(event.date)
    const year = dateObj.getFullYear()
    const month = dateObj.getMonth()

    if (sortMode === "absolute" && !isNaN(year)) {
      const decade = Math.floor(year / 10) * 10
      if (decade !== lastDecade) {
        elements.push(<DecadeHeader key={`decade-${decade}`} decade={decade} />)
        lastDecade = decade
      }
    } else if (sortMode === "monthDay" && !isNaN(month)) {
      if (month !== lastMonth) {
        elements.push(<MonthHeader key={`month-${month}`} month={month} />)
        lastMonth = month
      }
    }

    elements.push(
      <Box
        key={`event-${index}`}
        sx={{
          display: "flex",
          position: "relative",
          mb: 5,
        }}
      >
        {/* Hollow dot on the line */}
        <Box
          sx={{
            position: "absolute",
            left: "40px",
            transform: "translateX(-50%)",
            top: "55px", // Center of the 110px thumbnail
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            border: "2px solid #8C4E35",
            backgroundColor: "#FAF6F0", // Matches background
            zIndex: 2,
          }}
        />
        {/* Event Content */}
        <Box sx={{ ml: "70px", flexGrow: 1 }}>
          <EventCard event={event} />
        </Box>
      </Box>
    )
  })

  return (
    <SiteWrapper title="Family Timeline">
      <Helmet>
        <title>Timeline</title>
      </Helmet>

      {/* Main Container with warm cream background */}
      <Box
        sx={{
          backgroundColor: "#FAF6F0",
          minHeight: "calc(100vh - 64px)",
          py: { xs: 4, md: 6 },
          px: { xs: 2, sm: 4, md: 6 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Maximum Column Width for Editorial Look */}
        <Box sx={{ width: "100%", maxWidth: "800px" }}>
          
          {/* Custom Filters Controls Row */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              mb: 4,
              pb: 3,
              borderBottom: "1px solid #E6DFD5",
            }}
          >
            {/* Left side: Sort Toggles & Category Toggles */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 2,
              }}
            >
              {/* Sort Mode Toggle Group */}
              <Box
                sx={{
                  display: "flex",
                  border: "1px solid #D9CFC4",
                  borderRadius: "20px",
                  overflow: "hidden",
                  backgroundColor: "transparent",
                }}
              >
                <Box
                  onClick={() => setSortMode("absolute")}
                  sx={{
                    px: 3,
                    py: 1,
                    cursor: "pointer",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    letterSpacing: "0.05em",
                    backgroundColor: sortMode === "absolute" ? "#2B2621" : "transparent",
                    color: sortMode === "absolute" ? "#FAF6F0" : "#8A7C6E",
                    transition: "all 0.2s ease",
                    textTransform: "uppercase",
                    userSelect: "none",
                  }}
                >
                  Absolute Date
                </Box>
                <Box sx={{ width: "1px", backgroundColor: "#D9CFC4" }} />
                <Box
                  onClick={() => setSortMode("monthDay")}
                  sx={{
                    px: 3,
                    py: 1,
                    cursor: "pointer",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    letterSpacing: "0.05em",
                    backgroundColor: sortMode === "monthDay" ? "#2B2621" : "transparent",
                    color: sortMode === "monthDay" ? "#FAF6F0" : "#8A7C6E",
                    transition: "all 0.2s ease",
                    textTransform: "uppercase",
                    userSelect: "none",
                  }}
                >
                  Month / Day
                </Box>
              </Box>

              {/* Sort Direction Toggle */}
              <Box
                onClick={() => setSortDirection(sortDirection === "asc" ? "desc" : "asc")}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  border: "1px solid #D9CFC4",
                  cursor: "pointer",
                  color: "#8A7C6E",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    color: "#2B2621",
                    borderColor: "#8A7C6E",
                    backgroundColor: "rgba(0, 0, 0, 0.02)",
                  },
                }}
                title={sortDirection === "asc" ? "Sort Ascending (Oldest First)" : "Sort Descending (Newest First)"}
              >
                {sortDirection === "asc" ? (
                  <ArrowUpward sx={{ fontSize: "1.1rem" }} />
                ) : (
                  <ArrowDownward sx={{ fontSize: "1.1rem" }} />
                )}
              </Box>

              {/* Category Filter Toggles */}
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
                {["birthday", "mission", "anniversary"].map((cat) => {
                  const isSelected = selectedCategories.includes(cat)
                  return (
                    <Box
                      key={cat}
                      onClick={() => toggleCategory(cat)}
                      sx={{
                        px: 3,
                        py: 1,
                        cursor: "pointer",
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        letterSpacing: "0.05em",
                        borderRadius: "20px",
                        border: isSelected ? "1px solid #A65F41" : "1px solid #E6DFD5",
                        color: isSelected ? "#A65F41" : "#8A7C6E",
                        backgroundColor: isSelected ? "#F5EFE6" : "transparent",
                        transition: "all 0.2s ease",
                        textTransform: "uppercase",
                        userSelect: "none",
                        "&:hover": {
                          borderColor: isSelected ? "#A65F41" : "#8A7C6E",
                        },
                      }}
                    >
                      {cat}
                    </Box>
                  )
                })}
              </Box>
            </Box>

            {/* Right side: Family Multi-Select Dropdown */}
            <Box>
              <Box
                onClick={handleFamilyClick}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  cursor: "pointer",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  letterSpacing: "0.05em",
                  color: "#8A7C6E",
                  userSelect: "none",
                  py: 1,
                  px: 1.5,
                  borderRadius: "4px",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    color: "#2B2621",
                    backgroundColor: "rgba(0, 0, 0, 0.02)",
                  },
                }}
              >
                {getFamilyButtonText()}
                <span style={{ fontSize: "0.8rem", marginLeft: "2px" }}>▾</span>
              </Box>

              <Menu
                anchorEl={familyMenuAnchor}
                open={Boolean(familyMenuAnchor)}
                onClose={handleFamilyClose}
                slotProps={{
                  paper: {
                    sx: {
                      backgroundColor: "#FAF6F0",
                      border: "1px solid #E6DFD5",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                      borderRadius: "8px",
                      mt: 1,
                    },
                  },
                }}
              >
                {allFamiliesList.map((fam) => {
                  const isChecked = selectedFamilies.includes(fam)
                  return (
                    <MenuItem
                      key={fam}
                      onClick={() => toggleFamily(fam)}
                      sx={{
                        fontSize: "0.85rem",
                        color: "#6E6255",
                        py: 1,
                        px: 2.5,
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        "&:hover": {
                          backgroundColor: "#F5EFE6",
                        },
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={isChecked}
                        readOnly
                        style={{
                          accentColor: "#A65F41",
                          cursor: "pointer",
                          margin: 0,
                        }}
                      />
                      <span style={{ fontFamily: '"Kanit", sans-serif', fontWeight: 300 }}>
                        {fam}
                      </span>
                    </MenuItem>
                  )
                })}
              </Menu>
            </Box>
          </Box>

          {/* Timeline List Section */}
          {sortedData.length > 0 ? (
            <Box sx={{ position: "relative", width: "100%", mt: 4 }}>
              {/* Vertical Continuous Rail Line */}
              <Box
                sx={{
                  position: "absolute",
                  left: "40px",
                  top: "24px", // Align with first Decade/Month header or card
                  bottom: "55px", // End at center of last event dot
                  width: "1.5px",
                  backgroundColor: "#D9CFC4",
                  zIndex: 1,
                }}
              />
              {/* Elements List */}
              {elements}
            </Box>
          ) : (
            /* Empty State Fallback */
            <Box sx={{ textAlign: "center", py: 12 }}>
              <Typography
                sx={{
                  fontFamily: '"Playfair Display", Georgia, serif',
                  fontSize: "1.6rem",
                  color: "#8A7C6E",
                  mb: 1.5,
                }}
              >
                No Timeline Events Found
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Kanit", sans-serif',
                  fontSize: "0.95rem",
                  fontWeight: 300,
                  color: "#6E6255",
                }}
              >
                Try adjusting your category or family filters.
              </Typography>
            </Box>
          )}

        </Box>
      </Box>
    </SiteWrapper>
  )
}

export default FamilyTimeline
